e4.product.variants = {
    debug: false,
    colorGroupVariantPrices: window.colorGroupVariantPrices,
    init: function () {
        var jProduct = jQuery('.js-e-product');
        if (jProduct.data('hasVariants') === true) {
            e4.product.variants.event = e4.util.registerEvents('change changed', 'product.variants');
            jProduct.find('.js-e-product-form').each(function (intIndex, domForm) {
                e4.product.variants.updateAvailableOptionsInAllGroups(domForm);
                e4.product.variants.loadJsonProduct(domForm);
            });
            e4.product.variants.setColorFamilyPrices(jProduct.data('variantId'));
            e4.product.variants.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery('.js-e-product-form').one('change', function (event) {
            var strProductId = e4.product.variants.getProductId(event.currentTarget);
            //e4.product.variants.preloadImages( strProductId );
        }).find('.js-e-product-form-variant-group-input').on('change', function (event) {
            e4.product.variants.changeVariant(event.target);
        });

        jQuery('.js-theca-modal-material').find('.js-theca-modal-close').on('click', function () {
            var jElement = jQuery('.js-theca-modal-material');
            jElement.find('.js-e-product-form-variant-group-input[value="' + jElement.data('fallbackMaterial') + '"]').prop('checked', true);
            jElement.find('.js-e-product-form-variant-group-input[value="' + jElement.data('fallbackMaterial') + '"]').trigger('change');
        });

        jQuery('.js-theca-modal-material').on('show.bs.modal', function (event) {
            var jElement = jQuery(event.target);
            jElement.data('fallbackMaterial', jElement.find('.js-e-product-form-variant-group-input:checked').val());
        });

        //loaded.e4.jsonpublisher

        jQuery('.js-theca-accessories-productlist').on('loaded.e4.jsonpublisher', function (event) {
            e4.product.setAccessories();
            if (e4.product.variants.currentClickedVariantOptionInput != null) {
                e4.product.variants.changeColorFamilyPrice(e4.product.variants.currentClickedVariantOptionInput);
            }
        });

        jQuery('.js-theca-product-images').on('loaded.e4.jsonpublisher', function (event) {
            var primaryImage = jQuery(event.target).find('img').eq(0).attr('src');
            jQuery('.js-e-form-dw').find('input[name="ProductImage"]').val(window.location.origin + primaryImage);
            jQuery('.js-e-form-dw').find('input[name="SubmitPage"]').val(location.href);
        });
        e4.product.calcTotalPrice();
    },
    changeColorFamilyPrice: function (domInput) {
        var strVariantId = e4.product.variants.getVariantId(domInput.form),
            jInput = jQuery(domInput);
        if (jInput.attr('name').includes("_Material") === false) {
            e4.product.variants.setColorFamilyPrices(strVariantId);
        }
    },
    setColorFamilyPrices: function (strVariantId) {
        var boolIsUserAuthenticated = jQuery('.js-e-product').data('isuserauthenticated') === 'True';
        if (boolIsUserAuthenticated) {
            var strVariantId = String(strVariantId);
            var lastPartColorGroupVariantPricesKey = strVariantId.split('.').splice(1, strVariantId.split('.').length).join('.');
            var colorGroupVariantPricesKeys = [];
            jQuery('.js-theca-color-groups').each(function (intIndex, domElement) {
                var colorGroupVariantPricesKey = jQuery(domElement).data('colorfamily') + '_' + lastPartColorGroupVariantPricesKey;
                colorGroupVariantPricesKeys.push(colorGroupVariantPricesKey);
            });
            jQuery('.js-e-product').data('colorGroupVariantPricesKeys', colorGroupVariantPricesKeys);
            var postData = jQuery('.js-e-product').data();

            e4.product.variants.colorFamily.ajax({
                method: 'POST',
                data: postData,
            }, function (data) {
                e4.product.variants.colorGroupVariantPrices = data.colorGroupVariantPrices;
                jQuery('.js-theca-color-groups').each(function (intIndex, domElement) {
                    var colorGroupVariantPricesKey = jQuery(domElement).data('colorfamily') + '_' + lastPartColorGroupVariantPricesKey;
                    if (e4.product.variants.colorGroupVariantPrices[colorGroupVariantPricesKey] !== undefined) {
                        jQuery(domElement).find('.js-theca-colorfamily-price').html(e4.product.variants.colorGroupVariantPrices[colorGroupVariantPricesKey].formatted);
                    }
                });
            });
        }
    },
    colorFamily: {
        ajax: function (objAjaxSettings, fnCallback) {
            var jqXHR = jQuery.ajax(jQuery.extend({
                url: e4.settings.ecom.product.colorfamily.url + '?ProductID=' + objAjaxSettings.data.productId,
                method: 'POST',
                dataType: 'json',
                cache: false
            }, objAjaxSettings));
            jqXHR.done(function (data) {
                if (typeof fnCallback === 'function') {
                    fnCallback(data);
                }
            });
        }
    },
    setMailProductForm: function (jsonProduct) {
        /* Product Page Form */
        var jProductForm = jQuery('.js-theca-productform');
        jProductForm.find('input[name="ProductNumber"]').val(jsonProduct.thecaProductNumber);
        jProductForm.find('input[name="Upholstery"]').val(jsonProduct.materialNumber + " - " + jQuery(".js-theca-product-form-variant-form-group[data-variant-group='Material']").find('.js-theca-product-selected-option-value').html());
        jProductForm.find('input[name="Legs"]').val(jQuery(".js-theca-product-form-variant-form-group[data-variant-group='Legs']").find('.js-theca-product-selected-option-value').html());
    },
    onPageLoad: true,
    loadJsonProduct: function (domForm) {
        var dfdReturnValue = null,
            strProductId = e4.product.variants.getProductId(domForm),
            strVariantId = e4.product.variants.getVariantId(domForm);
        if (e4.product.variants.isVariantIdValid(strProductId, strVariantId) === true) {
            dfdReturnValue = e4.jsonpublisher.getJsonFromUrl(e4.settings.ecom.product.url, {
                productId: e4.product.variants.getProductId(domForm),
                variantId: e4.product.variants.getVariantId(domForm),
            }).done(function (jsonProduct) {
                // Update internal json data object used as source for all json publishers without their own url source.
                e4.data.set(jsonProduct.id, jsonProduct);
                if (e4.product.variants.onPageLoad) {
                    e4.product.variants.onPageLoad = false;
                    e4.product.variants.setMailProductForm(jsonProduct);
                } else {
                    e4.product.variants.updateImageContainer(jsonProduct.imageViewer);
                }
            });
        } else {
            dfdReturnValue = jQuery.Deferred().reject('Failed to load json variant product, productId and/or variantId is not valid.');
            dfdReturnValue.fail(function () {
                console.warn([
                    arguments,
                    e4.settings.ecom.product.url,
                    {
                        productId: e4.product.variants.getProductId(domForm),
                        variantId: e4.product.variants.getVariantId(domForm),
                    }
                ], e4.product.variants.debug);
            });
        }
        return dfdReturnValue.promise();
    },
    updateImageContainer: function (imageViewer) {
        var jProduct = jQuery('.js-e-product');
        var jCylindoViewer = jProduct.find('cylindo-viewer');
        var jImageViewer = jProduct.find('.js-e-product-images');
        if (imageViewer.code !== undefined) {
            jCylindoViewer.prop('code', imageViewer.code);
            jCylindoViewer.prop('configuration', imageViewer.configuration);
            jCylindoViewer.removeClass('d-none');
            jImageViewer.addClass('d-none');
        } else {
            jCylindoViewer.addClass('d-none');
            jImageViewer.removeClass('d-none');
        }
        
        
    },
    preloadImages: function (strProductId) {
        var arrVariantImages = [],
            fnLoadImages = function (arrImageSrc, intIndex) {
                intIndex = intIndex || 0;
                if (arrImageSrc && arrImageSrc.length > intIndex) {
                    var domImg = new Image();
                    domImg.onload = function () {
                        fnLoadImages(arrImageSrc, intIndex + 1);
                    };
                    domImg.onerror = function () {
                        fnLoadImages(arrImageSrc, intIndex + 1);
                    };
                    domImg.src = arrImageSrc[intIndex];
                }
            },
            jsonVariantCombinations = e4.data.get(e4.product.variants.getJsonPropertyPath(strProductId));
        jQuery.each(jsonVariantCombinations, function (strKey, objVariant) {
            //arrVariantImages.push( objVariant.imagePrimary.small );
            arrVariantImages.push(objVariant.imagePrimary.large);
            //jQuery.each( objVariant.imageDetails, function ( index, objImageUrl ) {
            //arrVariantImages.push( objImageUrl.small );
            //arrVariantImages.push( objImageUrl.large );
            //} );
        });
        fnLoadImages(arrVariantImages);
        //e4.util.debug( ['preloadImages', arrVariantImages], e4.product.variants.debug );
    },
    currentClickedVariantOptionInput: null,
    changeVariant: function (domInput) {
        var jProductForm = jQuery(domInput.form),
            jElement = jQuery(domInput),
            jProduct = jProductForm.closest('.js-e-product'),
            strProductId = e4.product.variants.getProductId(domInput.form),
            strVariantId = null, // Set initial value and wait for updateAvailableOptionsInAllGroups to run before getting the value, as it can change the selected options.
            arrJsonPublishers = {
                withUrlSource: [],
                withoutUrlSource: []
            };

        jQuery('.js-theca-modal-material').find('.js-e-loading-overlay').addClass('is-loading');
        e4.product.variants.currentClickedVariantOptionInput = domInput;

        e4.product.variants.updateAvailableOptionsInAllGroups(domInput.form);
        strVariantId = e4.product.variants.getVariantId(domInput.form);
        if (e4.product.variants.isVariantIdValid(strProductId, strVariantId) === true) {
            jProduct.trigger(e4.product.variants.event.change);
            e4.util.debug([
                'Changing variant to',
                strVariantId,
                'and updating content.'
            ], e4.product.variants.debug);
            // Get all json publishers inside product element that needs to be updated on variant change.
            jProduct.find('.js-e-jsonpublisher').each(function (index, domNode) {
                var jJsonPublisher = jQuery(domNode);
                // Collect elements with and without url sources in separate collections to update so they can be updated on different callbacks.
                if (jJsonPublisher.hasClass('js-jsonpublisher-once') === false) {
                    if (e4.jsonpublisher.isJsonSrcUrl(e4.util.stringify(jJsonPublisher.data('jsonSrc'))) === true) {
                        arrJsonPublishers.withUrlSource.push(domNode);
                    } else {
                        arrJsonPublishers.withoutUrlSource.push(domNode);
                    }
                }
            });
            e4.product.variants.setVariantId(domInput.form, strVariantId);
            jProductForm.addClass('is-loading');
            // Get new json product data to update all json publishers without their own url source.
            e4.product.variants.loadJsonProduct(domInput.form).done(function (jsonProduct) {
                e4.product.variants.setDetailsOnElementsWithoutUrlSource(jProduct, jsonProduct, arrJsonPublishers.withoutUrlSource);
                e4.product.variants.setUrl(jsonProduct);
                jProductForm.removeClass('is-loading');
                jProduct.trigger(e4.product.variants.event.changed, jsonProduct);
                jQuery('.js-theca-modal-material').find('.js-e-loading-overlay').removeClass('is-loading');
            });
            // Update all json publishers with url source.
            e4.product.variants.setDetailsOnElementsWithUrlSource(jProduct, strProductId, strVariantId, arrJsonPublishers.withUrlSource);
        } else {
            e4.product.variants.clearVariantId(domInput.form);
            e4.util.debug([
                'Cannot change variant.',
                strVariantId,
                'is not a valid variantId.'
            ], e4.product.variants.debug);
        }
    },
    isVariantIdValid: function (strProductId, strVariantId) {
        // console.log(jQuery.inArray( strVariantId, e4.data.get( strProductId + '_VariantCombinationIds' ) ),e4.data.get( strProductId + '_VariantCombinationIds' ), strVariantId)
        return jQuery.inArray(strVariantId, e4.data.get(strProductId + '_VariantCombinationIds')) > -1;
    },
    getVariantId: function (domForm) {
        var arrGroupsValue = [];
        jQuery(domForm).find('.js-e-product-form-variant-form-group').each(function (intIndex, domNode) {
            var jGroup = jQuery(domNode),
                jGroupInput = e4.product.variants.getGroupInput(jGroup);
            arrGroupsValue.push(e4.product.variants.getGroupInputValue(jGroupInput));
        });
        return arrGroupsValue.join('.');
    },
    setVariantId: function (domForm, strVariantId) {
        jQuery(domForm).find('input[name="VariantID0"]').val(strVariantId);
    },
    clearVariantId: function (domForm) {
        e4.product.variants.setVariantId(domForm, '');
    },
    getProductId: function (domForm) {
        return jQuery(domForm).find('input[name="ProductID0"]').val();
    },
    getAvailableOptionsForNextGroup: function (objVariantMap) {
        var objOptions = null;
        if (objVariantMap !== null && objVariantMap.options !== undefined) {
            objOptions = objVariantMap.options;
        }
        return objOptions;
    },
    getNextVariantMap: function (strVariantOptionId, objVariantMap) {
        var objGroup = null;
        if (objVariantMap !== null && objVariantMap.options !== undefined && objVariantMap.options[strVariantOptionId] !== undefined) {
            objGroup = objVariantMap.options[strVariantOptionId];
        }
        e4.util.debug([
            'Getting next map from',
            objVariantMap,
            'with key',
            strVariantOptionId,
            'returning',
            objGroup
        ], e4.product.variants.debug);
        return objGroup;
    },
    getNextGroupId: function (objVariantMap) {
        var strGroupId = '';
        if (objVariantMap !== null && objVariantMap.options !== undefined) {
            jQuery.each(objVariantMap.options, function (strKey, objValue) {
                strGroupId = objValue.groupId;
                // Return false to break jQuery.each loop.
                return false;
            });
        }
        return strGroupId;
    },
    getNextGroup: function (jGroup, jGroups) {
        var intNextGroupIndex = jGroups.index(jGroup) + 1;
        return jGroups.eq(intNextGroupIndex);
    },
    getGroupName: function (jGroup) {
        return jGroup.find('label').first().text();
    },
    getGroupInput: function (jGroup) {
        return jGroup.find('select,input[type="radio"]');
    },
    getGroupInputType: function (jGroupInput) {
        var strInputType = null,
            domInput = jGroupInput.get(0),
            strTypeAttr = jGroupInput.attr('type');
        if (domInput !== undefined) {
            if (strTypeAttr !== undefined) {
                strInputType = strTypeAttr.toLowerCase();
            } else {
                strInputType = domInput.nodeName.toLowerCase();
            }
        }
        return strInputType;
    },
    getGroupInputValue: function (jGroupInput) {
        var strInputValue = null;
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            strInputValue = jGroupInput.val();
        } else {
            strInputValue = jGroupInput.filter(':checked').val();
        }
        if (strInputValue === undefined || strInputValue === '') {
            strInputValue = null;
        }
        return strInputValue;
    },
    getGroupInputOptions: function (jGroupInput) {
        var jGroupInputOptions = jGroupInput;
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            jGroupInputOptions = jGroupInputOptions.find('option').not('[value=""]');
        }
        return jGroupInputOptions;
    },
    getGroupInputOptionName: function (jGroupInput, jGroupInputOption) {
        var strOptionText = null;
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            strOptionText = jGroupInputOption.text();
        } else {
            strOptionText = jGroupInputOption.attr('title');
            if (strOptionText === undefined) {
                strOptionText = jGroupInputOption.closest('label').text();
            }
        }
        return strOptionText;
    },
    deSelectGroupOptions: function (jGroupInput) {
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            jGroupInput.val('');
        } else {
            e4.product.variants.getGroupInputOptions(jGroupInput).prop('checked', false);
        }
    },
    selectGroupInputOption: function (jGroupInput, jGroupInputOption) {
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            jGroupInputOption.prop('selected', true);
        } else {
            jGroupInputOption.prop('checked', true);
        }
    },
    isOptionSelected: function (jGroupInput, jGroupInputOption) {
        var isSelected;
        if (e4.product.variants.getGroupInputType(jGroupInput) === 'select') {
            isSelected = jGroupInputOption.prop('selected') === true;
        } else {
            isSelected = jGroupInputOption.prop('checked') === true;
        }
        return isSelected;
    },
    enableGroupInputOptions: function (jGroupInput) {
        e4.product.variants.getGroupInputOptions(jGroupInput).prop('disabled', false);
    },
    updateAvailableOptionsInAllGroups: function (domForm) {
        var strProductId = e4.product.variants.getProductId(domForm),
            jGroups = jQuery(domForm).find('.js-e-product-form-variant-form-group'),
            objVariantMap = e4.data.get([
                strProductId,
                'VariantCombinationTree'
            ].join('_')),
            isGroupSelectionCleared = false;

        e4.util.debug(['--- --- updateAvailableOptionsInAllGroups --- START', objVariantMap], e4.product.variants.debug);
        jGroups.each(function (intIndex, domNode) {
            var jGroup = jQuery(domNode),
                jGroupInput = e4.product.variants.getGroupInput(jGroup),
                strVariantOptionId = e4.product.variants.getGroupInputValue(jGroupInput),
                jNextGroup = e4.product.variants.getNextGroup(jGroup, jGroups),
                jNextGroupInput = e4.product.variants.getGroupInput(jNextGroup),
                jNextGroupInputOptions = e4.product.variants.getGroupInputOptions(jNextGroupInput),
                objAvailableOptionsForNextGroup = null;
            e4.util.debug([
                'GROUP:',
                e4.product.variants.getGroupName(jGroup),
                'VALUE:',
                e4.product.variants.getGroupInputValue(jGroupInput),
                'isGroupSelectionCleared is',
                isGroupSelectionCleared
            ], e4.product.variants.debug);

            // Get next level from variant map.
            objVariantMap = e4.product.variants.getNextVariantMap(strVariantOptionId, objVariantMap);
            // Get options from variant map.
            objAvailableOptionsForNextGroup = e4.product.variants.getAvailableOptionsForNextGroup(objVariantMap);

            // Release all options in group if previous group selection was cleared or has no selected options.
            if (isGroupSelectionCleared === true || objAvailableOptionsForNextGroup === null) {
                isGroupSelectionCleared = true;
                e4.product.variants.enableGroupInputOptions(jNextGroupInput);
                e4.util.debug([
                        'Enable all group options on',
                        e4.product.variants.getGroupName(jNextGroup),
                        'after deSelectGroupOptions on previous group.'
                    ], e4.product.variants.debug
                );
            } else {
                jNextGroupInputOptions.prop('disabled', function () {
                    var jNextGroupOption = jQuery(this),
                        strOptionValue = jNextGroupOption.attr('value'),
                        isOptionAvailable = false;
                    // Loop all available options on next group and save disabled state.
                    for (var strVariantOptionId in objAvailableOptionsForNextGroup) {
                        if (strOptionValue === strVariantOptionId) {
                            isOptionAvailable = true;

                            // If we find a match, we dont need to look any further.
                            break;
                        }
                    }
                    e4.util.debug([
                        'Option',
                        e4.product.variants.getGroupInputOptionName(jNextGroupInput, jNextGroupOption),
                        '(',
                        strOptionValue,
                        ') isOptionAvailable: ',
                        isOptionAvailable
                    ], e4.product.variants.debug);
                    // If current option already is selected and has been disabled, we need to reset the current
                    // select/input.
                    if (isOptionAvailable === false && e4.product.variants.isOptionSelected(jNextGroupInput, jNextGroupOption) === true) {
                        e4.product.variants.deSelectGroupOptions(jNextGroupInput);
                        isGroupSelectionCleared = true;
                        e4.util.debug([
                            'Group selection is cleared on',
                            e4.product.variants.getGroupName(jNextGroup),
                            'because selected option',
                            e4.product.variants.getGroupInputOptionName(jNextGroupInput, jNextGroupOption),
                            '(',
                            strOptionValue,
                            ') was unavailable and has been deselected and disabled.'
                        ], e4.product.variants.debug);
                    }

                    // Return disabled state to filter function.
                    return isOptionAvailable === false;
                });

                // Auto selct first available option in group if settings and conditions allow it.
                if (e4.product.variants.shallWeAutoSelectFirstAvailableOption(jNextGroupInputOptions, isGroupSelectionCleared) === true) {
                    var jNextGroupInputOptionsSelectable = jNextGroupInputOptions.not(':disabled');
                    e4.product.variants.selectGroupInputOption(jNextGroupInput, jNextGroupInputOptionsSelectable.first());
                    isGroupSelectionCleared = false;
                    e4.util.debug([
                        'Auto selecting first option',
                        e4.product.variants.getGroupInputOptionName(jNextGroup, jNextGroupInputOptionsSelectable.first()),
                        '(',
                        e4.product.variants.getGroupInputValue(jNextGroupInput),
                        ') in group',
                        e4.product.variants.getGroupName(jNextGroup),
                        'because group selection was unavailable and has been cleared.'
                    ], e4.product.variants.debug);
                }
            }
        });
        e4.util.debug(['--- --- updateAvailableOptionsInAllGroups --- END'], e4.product.variants.debug);
    },
    shallWeAutoSelectFirstAvailableOption: function (jGroupInputOptions, isGroupSelectionCleared) {
        var boolAutoSelect = false;
        if (e4.settings.ecom.variants.autoSelect === true && isGroupSelectionCleared === true && jGroupInputOptions.not(':disabled').length > 0) {
            boolAutoSelect = true;
        }
        return boolAutoSelect;
    },
    getJsonPropertyPath: function (strProductId, strVariantId) {
        var strPropertyPath = null,
            arrPropertyPath = [];
        if (strProductId !== undefined && strProductId !== '') {
            arrPropertyPath.push(strProductId);
            arrPropertyPath.push('variantCombinations');
            if (strVariantId !== undefined && strVariantId !== '') {
                arrPropertyPath.push(strVariantId);
            }
            strPropertyPath = arrPropertyPath.join('.');
        }
        return strPropertyPath;
    },
    /* jshint ignore:start */
    setDetailsOnElementsWithUrlSource: function (jProduct, strProductId, strVariantId, arrJsonPublishersWithUrlSource
    ) {
        var objJsonSettings = {
            jsonSrcGetParams: {
                productId: strProductId,
                variantId: strVariantId
            }
        };
        jQuery.each(arrJsonPublishersWithUrlSource, function (index, domNode) {
            e4.jsonpublisher.reload(domNode, objJsonSettings);
        });
    },
    /* jshint ignore:end */
    setDetailsOnElementsWithoutUrlSource: function (jProduct, jsonProduct, arrJsonPublishersWithoutUrlSource) {
        var objJsonSettings = {};
        jQuery.each(arrJsonPublishersWithoutUrlSource, function (index, domNode) {
            e4.jsonpublisher.reload(domNode, objJsonSettings);
        });

        jProduct.find('.js-theca-product-form-variant-form-group').each(function (intIndex, domElement) {
            var jElement = jQuery(domElement);
            var strSelectedOptionName = jsonProduct.variantGroups[jElement.data('variantGroup')].selectedOptionName;
            jElement.find('.js-theca-product-selected-option-value').html(strSelectedOptionName);
        });

        jProduct.find('.js-theca-product-width').html(jsonProduct.assembledWidth);
        jProduct.find('.js-theca-product-depth').html(jsonProduct.assembledDepth);
        jProduct.find('.js-theca-product-height').html(jsonProduct.assembledHeight);


        var jCartForm = jQuery('.js-e-product-form-addtocart, .e-product-form-removefromcart');

        jCartForm.find('input[Name="ProductID"]').val(jsonProduct.id);
        jCartForm.find('input[Name="VariantID"]').val(jsonProduct.variantId);

        jQuery('.js-e-product').attr('data-variant-id', jsonProduct.variantId);
        e4.download.toogleIsInCart();

        var strCombination = jsonProduct.category1;
        if (jsonProduct.category2 != '') {
            strCombination = theca.string.format('{0} + {1}', jsonProduct.category1, jsonProduct.category2);
        }

        var strFabricName = '';
        var strFabricId = '';
        if (jsonProduct.variantGroups['Material'] !== undefined) {
            strFabricName = jsonProduct.variantGroups['Material'].selectedOptionName;
            strFabricId = jsonProduct.variantGroups['Material'].selectedOptionId;
        }

        var strMaterialUpholsteryBtnImage = theca.string.format('url(\'/admin/public/getimage.ashx?Image=/Files/Images/upholstery/{0}.jpg&Width=250&Height=250&Format=jpg&Quality=75&Crop=0\')', strFabricId);

        jProduct.find('.js-btn-material-selected-option').css({
            'background-image': strMaterialUpholsteryBtnImage
        });

        jProduct.find('.js-theca-product-combination').html(strCombination);
        var variantDescription = strCombination;
        if (strFabricName !== '') {
            variantDescription += theca.string.format(' · {0}', strFabricName.split(jsonProduct.colorname).join(''));
        }

        if (jsonProduct.colorname !== '') {
            variantDescription += theca.string.format(' · {0}', jsonProduct.colorname);
        }

        //jProduct.find('.js-theca-product-variant-description').html(theca.string.format('{0} · {1}· {2}', strCombination, strFabricName.split(jsonProduct.colorname).join(''), jsonProduct.colorname));
        jProduct.find('.js-theca-product-variant-description').html(variantDescription);
        jProduct.find('.js-e-product-name').html(jsonProduct.modelName);
        jProduct.find('.js-theca-product-number').html(jsonProduct.thecaProductNumber);
        jProduct.find('.js-btn-material-selected-option').attr('data-content', strFabricName);
        e4.product.variants.setMailProductForm(jsonProduct);

        jQuery('.js-theca-product-price-formatted').data('unitprice', jsonProduct.price.value);
        e4.product.calcTotalPrice();
        jProduct.find('.js-theca-product-stock-deliverytext').html(jsonProduct.stock.deliveryText);
    },
    setUrl: function (jsonProduct) {
        if (jsonProduct.link !== undefined && jsonProduct.link.indexOf('/') === 0) {
            history.replaceState(null, '', jsonProduct.link);
        }
    }
};
